// extracted by mini-css-extract-plugin
export default {"root":"ViewSelector__root__ORQVz","icon":"ViewSelector__icon__h9bzf"};